'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dLocale$0024$002dCategory from "./java.util.-Locale$-Category.js";
import * as $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024$0024anon$00242 from "./java.util.-Locale$-Category$$anon$2.js";
import * as $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024$0024anon$00243 from "./java.util.-Locale$-Category$$anon$3.js";
var $p;
function $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__DISPLAY;
}
export { $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category as $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category };
function $s_ju_Locale$Category$__FORMAT__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__FORMAT;
}
export { $s_ju_Locale$Category$__FORMAT__ju_Locale$Category as $s_ju_Locale$Category$__FORMAT__ju_Locale$Category };
/** @constructor */
function $c_ju_Locale$Category$() {
  this.JW = null;
  $n_ju_Locale$Category$ = this;
  $t_ju_Locale$Category$__DISPLAY = new $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024$0024anon$00242.$c_ju_Locale$Category$$anon$2();
  $t_ju_Locale$Category$__FORMAT = new $j_java$002eutil$002e$002dLocale$0024$002dCategory$0024$0024anon$00243.$c_ju_Locale$Category$$anon$3();
  this.JW = new ($j_java$002eutil$002e$002dLocale$0024$002dCategory.$d_ju_Locale$Category.r().C)([$s_ju_Locale$Category$__DISPLAY__ju_Locale$Category(), $s_ju_Locale$Category$__FORMAT__ju_Locale$Category()]);
}
export { $c_ju_Locale$Category$ as $c_ju_Locale$Category$ };
$p = $c_ju_Locale$Category$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Locale$Category$;
/** @constructor */
function $h_ju_Locale$Category$() {
}
export { $h_ju_Locale$Category$ as $h_ju_Locale$Category$ };
$h_ju_Locale$Category$.prototype = $p;
$p.Yo = (function() {
  return this.JW.x();
});
var $d_ju_Locale$Category$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$Category$, "java.util.Locale$Category$", ({
  nd: 1,
  e: 1,
  aa: 1
}));
export { $d_ju_Locale$Category$ as $d_ju_Locale$Category$ };
var $n_ju_Locale$Category$;
function $m_ju_Locale$Category$() {
  if ((!$n_ju_Locale$Category$)) {
    $n_ju_Locale$Category$ = new $c_ju_Locale$Category$();
  }
  return $n_ju_Locale$Category$;
}
export { $m_ju_Locale$Category$ as $m_ju_Locale$Category$ };
var $t_ju_Locale$Category$__DISPLAY = null;
function $u_ju_Locale$Category$__DISPLAY(x) {
  $t_ju_Locale$Category$__DISPLAY = x;
}
export { $t_ju_Locale$Category$__DISPLAY as $t_ju_Locale$Category$__DISPLAY, $u_ju_Locale$Category$__DISPLAY as $u_ju_Locale$Category$__DISPLAY };
var $t_ju_Locale$Category$__FORMAT = null;
function $u_ju_Locale$Category$__FORMAT(x) {
  $t_ju_Locale$Category$__FORMAT = x;
}
export { $t_ju_Locale$Category$__FORMAT as $t_ju_Locale$Category$__FORMAT, $u_ju_Locale$Category$__FORMAT as $u_ju_Locale$Category$__FORMAT };
